export async function createForeignPersonalInfo(foreignPersonalInfoRepository, foreignPersonalInfo) {
  return foreignPersonalInfoRepository.save(foreignPersonalInfo)
}